<p>
  deletelead works!
</p>



// WEBPACK FOOTER //
// ./src/app/platform/lead/deletelead/deletelead.component.html